module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-grey-200",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('main-nav'), _vm._v(" "), (_vm.bannerEnabled) ? _c('install', {
    on: {
      "install": _vm.onInstallBanner,
      "close": _vm.onCloseBanner
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-38bdfdd5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 109
// module chunks = 2